angular.module('impactx.dashboard').controller('DashboardGRNNewsCtrl', ['$scope', 'dataGen', '$redirect', DashboardGRNNewsCtrl]);

function DashboardGRNNewsCtrl($scope, dataGen, $redirect) {
    dataGen.getData($scope, {}, "/dashboard/grnnews").then(function () {
        $scope.isHidden.value = !$scope.data.showPanel;
    })

    $scope.goToDetailPage = function (route) {
        if (route) {
            $redirect.redirectTo(null, route);
        }
    };
}